import { CalendarDate } from '@internationalized/date';

// Realistic lower bound for entered dates; also keeps calendarDateToIso safe,
// since Date.UTC maps years 0-99 to 1900-1999. Shared with the calendar so
// the typed field and the picker enforce the same range.
export const MIN_DATE = new CalendarDate(1900, 1, 1);
